module.exports = __webpack_public_path__ + "img/lideranca-icon.0ae41407.png";